import React, { useState, useEffect, useRef } from "react";
import { confirmAlert } from "react-confirm-alert";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { actions } from "../redux/authRedux";
import { resetRedux, saveBookingCarStatus, saveBookingStatus, saveComment, saveCountCV, saveLike, saveNotification, savePosts, saveRealTimeData, saveRefreshSocket, saveReloadBCC, saveWorkfollow, setResetPost } from "../redux/Actions";
import onClickOutside from "react-onclickoutside";
import noibo from "../assets/img/blue-icon.png";
import noiboicon from "../assets/img/bhs-noibo.png";
// import Pusher from "pusher-js";

import parse from 'html-react-parser'
import Avatar from "../assets/img/figure/admin.jpg";
import { URL_LIST_ALL } from "../configs/api";
import Axios from "axios";
import { jwtDecode } from "jwt-decode";
import wavFile from "../assets/notification.wav"
import { Html5Qrcode } from "html5-qrcode";
import { Modal } from "react-bootstrap";
import _ from 'lodash';

import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyDIE0wmEYGdQm4ABYHehiLsf9XNo6A5YlA",
  authDomain: "noibobhsgroup.firebaseapp.com",
  projectId: "noibobhsgroup",
  messagingSenderId: "149459105288",
  storageBucket: "noibobhsgroup.firebasestorage.app",
  appId: "1:149459105288:web:f37654edc50f88ec5883bd"
};

const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
const isSupportedBrowser = 'Notification' in window && 'serviceWorker' in navigator;


function HeaderBar({ toogleMenu, onToogleMenu }) {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const [show, setShow] = useState(false);
  const info = user && user.data ? user.data : null;
  const [socket, setSocket] = useState(null);
  const [showNoti, setShowNoti] = useState(false);
  const [refreshNoti, setRefreshNoti] = useState(false);
  const [listNotification, setListNotification] = useState(null);
  const [countNoti, setCountNoti] = useState(0);
  const [soundPlay, setSoundPlay] = useState(false);
  const [dataNotifi, setDataNotifi] = useState(null);
  const [showQrCode, setShowQrcode] = useState(false);
  const [qrResult, setQrResult] = useState(null);
  const isStoppingRef = useRef(false);

  const qrScannerRef = useRef(null);
  //Hàm xử lý đăng xuất
  const dologout = () => {
    confirmAlert({
      title: "Đăng xuất",
      message: "Bạn có chắc muốn đăng xuất",
      closeOnEscape: true,
      closeOnClickOutside: true,
      buttons: [
        {
          label: "Đăng xuất",
          onClick: () => {
            dispatch(resetRedux());
            dispatch(actions.login(null));
          },
        },
        { label: "Không" },
      ],
    });
  };
  HeaderBar["handleClickOutside_header"] = () => {
    setShow(false);
    setShowNoti(false)
  }

  useEffect(() => {
    const connectWebSocket = () => {
      // setFlag(true)
      const socketInstance = new WebSocket('wss://socket.bhsgroup.vn');
      socketInstance.onopen = () => { };
      socketInstance.onmessage = (evt) => {
        if (evt.data) {
          let data = evt.data
          try {
            data = jwtDecode(data)
            if (data) {
              if (data.channel && data.channel == 'bhs_socket') {
                let sound = 1;

                if (data.event == 'realtime') {
                  dispatch(saveRealTimeData(data.data))
                }
                if (data.event == 'user_logout' && data.data == user.data.id) {
                  dispatch(resetRedux());
                  dispatch(actions.login(null));
                }
                if (data.event == 'booking_status') {
                  dispatch(saveBookingStatus(data.data))
                }
                if (data.event == 'bookingcar_status') {
                  dispatch(saveBookingCarStatus(data.data))
                }
                if (data.data.action == 'posts_comment') {
                  sound = 0
                  dispatch(saveComment(data.data.data_send));
                }
                if (data.data.action == 'postlike') {
                  dispatch(saveLike(data.data.data_send));
                  sound = 0
                }
                if (data.data.action == 'posts') {
                  dispatch(savePosts(data.data.data_send));
                  sound = 0
                }
                if (data.data.action == 'workfollow') {
                  dispatch(saveWorkfollow(data.data));
                  sound = 0
                }
                if (data.data.action == 'export_bcc') {
                  dispatch(saveReloadBCC(data.data));
                  sound = 0
                }
                if (data.data.action == 'room_booking' || data.data.action == 'car_booking') {
                  dispatch(saveNotification({ action: data.data.action, datebooking: data.data.datebooking }))
                }
                if (data.data.to_user_id == user.data.id || data.data.to_user_id == "000") {
                  if (data.event == 'notifications' && (data.data.to_user_id == user.data.id || data.data.to_user_id == "000")) {
                    setRefreshNoti(data.data)
                    if (data.data.node_type != dataNotifi) setDataNotifi(data.data.node_type)
                    if (data.event && data.event == 'post' + user.data.id) {
                      dispatch(setResetPost(data.data));
                    }
                  }
                  dispatch(saveRefreshSocket(data));
                  if (sound == 1) setSoundPlay(true)

                }
              }
            }
          } catch (error) {
          }
        }
      };
      socketInstance.onclose = (event) => {
        setTimeout(() => {
          connectWebSocket();
        }, 1000);
      };
      setSocket(socketInstance);
    };
    if (!socket) {
      connectWebSocket();
    }
    return () => {
      if (socket) {
        socket.close();
      }
    };
  }, [socket]);

  const markSeen = (id, href = null) => {
    Axios.put(URL_LIST_ALL + "notifications/" + id, { seen: 1 }, user.config).then(async (res) => {
      if (href) {
        window.location.href = href
      } else {
        setListNotification((prev) =>
          prev.map((item) =>
            item.id === id ? { ...item, seen: 1 } : item
          )
        );
      }
    }).finally(() => {
      setRefreshNoti(!refreshNoti)
    })
  }
  const markSeenAll = (id, href = null) => {
    Axios.post(URL_LIST_ALL + "seenall", {}, user.config).then(async (res) => {
      if (href) {
        window.location.href = href
      } else {
        document.title = 'BHS - Nội bộ'
        setListNotification(prev =>
          prev.map(item => ({ ...item, seen: 1 }))
        );
      }
    }).finally(() => {
      setRefreshNoti(!refreshNoti)
    })
  }
  useEffect(() => {
    if (user.data) {
      Axios.get(URL_LIST_ALL + "notifications?limit=30&to_user_code=" + user.data.code, user.config).then(async (res) => {
        if (res.data.status === 'success') {
          let datars = res.data.data
          if (res.data && res.data.expert && res.data.expert == 1) {
            dispatch(resetRedux());
            dispatch(actions.login(null));
          }

          setListNotification(datars)
          let count_no_seen = 0
          datars.forEach((item) => {
            if (item.seen == 0 || !item.seen) {
              count_no_seen += 1;
            }
          });
          // console.log(count_no_seen);
          if (count_no_seen > 99) {
            count_no_seen = 99
          }
          if (count_no_seen > 0) document.title = 'BHS - Nội bộ (' + count_no_seen + ' thông báo)';
          setCountNoti(count_no_seen)
          if (res.data.countcv) {
            dispatch(saveCountCV(res.data.countcv))
          }

          if (res.data.roles && user.data.roles) {
            const localRole = structuredClone(JSON.parse(user.data.roles))
            const svRole = JSON.parse(res.data.roles);
            const isEqual = _.isEqual(localRole, svRole);
            // console.log(isEqual);
            if (!isEqual) {
              let newUser = Object.assign({}, user);
              newUser.data.roles = res.data.roles
              dispatch(actions.login(newUser));
            }
          }
        } else {
          alert(res.data.message)
        }
      }).catch((err) => { console.log(err); });
    }
  }, [user.data, refreshNoti])

  useEffect(() => {
    if (soundPlay) {
      try {
        const audio = new Audio(wavFile);
        audio.play()
      } catch (error) {

      }
      setSoundPlay(false)
    }
  }, [soundPlay]);
  useEffect(() => {
    if (dataNotifi) {
      showNotification(dataNotifi)
    }
  }, [dataNotifi]);

  const showNotification = (message) => {
    const regex = /(<([^>]+)>)/gi;
    message = message.replace(regex, "");

    if (!("Notification" in window)) {
      console.log("Trình duyệt không hỗ trợ Notifications API.");
      return;
    }

    if (Notification.permission === "granted") {
      if (navigator.serviceWorker && navigator.serviceWorker.ready) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.showNotification("BHS - Thông báo", {
            body: message,
            icon: noiboicon,
          });
        });
      }
    } else if (Notification.permission !== "denied") {
      Notification.requestPermission().then((permission) => {
        if (permission === "granted") {
          if (navigator.serviceWorker && navigator.serviceWorker.ready) {
            navigator.serviceWorker.ready.then((registration) => {
              registration.showNotification("BHS - Thông báo", {
                body: message,
                icon: noiboicon,
              });
            });
          }
        }
      });
    }
  };

  useEffect(() => {
    if (!isSupportedBrowser) {
      console.warn('Trình duyệt không hỗ trợ Notification hoặc Service Worker.');
      return;
    }

    Notification.requestPermission().then((permission) => {
      if (permission !== 'granted') {
        console.warn('User denied notification permission');
        return;
      }

      if (!isIOS) {
        // ✅ Firebase setup chỉ cho Android / Chrome / không phải iOS
        const app = initializeApp(firebaseConfig);
        const messaging = getMessaging(app);

        navigator.serviceWorker.register('/firebase-messaging-sw.js')
          .then((registration) => {
            console.log('Service Worker registered');

            getToken(messaging, {
              vapidKey: 'BI_9l_QiAQzNw6mAM3xgmL-DprqG2qEko6xJYS3nfqXKnOxxpTgY64v-VKvRraHxWsAXoKdhFIVuDoTZkgTNF1c',
              serviceWorkerRegistration: registration,
            }).then((token) => {
              // console.log('FCM Token:', token);
              // TODO: Gửi token lên server để gửi push về sau
            }).catch(err => {
              console.error('Lỗi lấy FCM token:', err);
            });

            // Nhận tin khi app đang mở
            onMessage(messaging, (payload) => {
              console.log('Foreground message:', payload);
              const { title, body, icon } = payload.notification;
              registration.showNotification(title, {
                body,
                icon: icon || noiboicon,
              });
            });
          }).catch(err => {
            console.error('Lỗi đăng ký service worker:', err);
          });

      } else {
        // ✅ iOS fallback - chỉ hiển thị Notification khi đang mở
        console.log('iOS detected, fallback dùng Notification API');
      }
    });
  }, []);


  useEffect(() => {
    const initQrScanner = async () => {
      if (showQrCode && !qrScannerRef.current) {
        const scanner = new Html5Qrcode("reader");
        try {
          const devices = await Html5Qrcode.getCameras();
          if (devices && devices.length > 0) {
            const cameraId = devices[1] ? devices[1].id : devices[0].id;
            await scanner.start(
              { facingMode: "environment" },
              { fps: 10, qrbox: 250 },
              async (decodedText) => {
                console.log("QR Code scanned:", decodedText);
                try {
                  await scanner.stop();
                } catch (err) {
                  console.warn("Stop error", err);
                }
                qrScannerRef.current = null;
                if (/^https?:\/\//.test(decodedText)) {
                  window.location.href = decodedText;
                } else {
                  setQrResult(decodedText);
                }
                setShowQrcode(false);
              },
              (errorMessage) => {
                console.warn("Scan error:", errorMessage);
              }
            );
            qrScannerRef.current = scanner;
          }
        } catch (err) {
          console.error("QR Scanner error:", err);
        }
      }
    };

    initQrScanner();

    return () => {
      if (qrScannerRef.current && !isStoppingRef.current) {
        isStoppingRef.current = true;
        qrScannerRef.current.stop()
          .then(() => {
            qrScannerRef.current = null;
            isStoppingRef.current = false;
          })
          .catch((err) => {
            console.warn("Stop error:", err);
            isStoppingRef.current = false;
          });
      }
    };
  }, [showQrCode]);



  return (
    <>
      {/* Header Menu Area Start Here */}
      <div className="navbar navbar-expand-md header-menu-one bg-light">
        {/* <PushSetup /> */}
        <div className="nav-bar-header-one">
          <div className="header-logo">
            <Link to="/">
              <img src={noibo} alt="logo" />
            </Link>
          </div>
          <div className="toggle-button sidebar-toggle">
            <button type="button" className="item-link">
              <span className="btn-icon-wrap">
                <span></span>
                <span></span>
                <span></span>
              </span>
            </button>
          </div>
        </div>
        <div className="d-md-none mobile-nav-bar">
          <div className='qr-group'>
            <button type="button" className="btn border" onClick={() => setShowQrcode(!showQrCode)}><i className="fas fa-qrcode text-white"></i></button>
          </div>
          <div className={"navbar-item notification-bar dropdown " + (showNoti ? 'show' : '')}>
            <button className="navbar-nav-link dropdown-toggle"
              type="button"
              role="button"
              data-toggle="dropdown"
              aria-expanded="false"
              onClick={() => setShowNoti(!showNoti)}
            >
              <i className="fas fa-bell"></i>
              {countNoti > 0 && <span className="count-number">{countNoti}</span>}
            </button>
            <div className={`dropdown-menu dropdown-menu-right ${showNoti ? "show" : ""}`} >
              <div className="w-100 d-flex justify-content-end border-bottom">
                <button className="btn readall" type="button" onClick={() => markSeenAll()}>Đánh dấu đọc tất cả</button>
              </div>
              {listNotification ? listNotification.map((item, i) => {
                return (<div className={"notification-item p-2 " + (item.seen === 1 ? "seen" : '')} key={i}>
                  {item.avatar ?
                    <img src={item.avatar} alt="" className="avatar" />
                    :
                    ''
                  }
                  <div className="content pl-2" onClick={() => { markSeen(item.id, item.node_url) }}>
                    <div className="w-100">
                      {parse(item.node_type)}
                    </div>
                    <div className="timmer">
                      <small>Lúc {item.time}</small>
                    </div>
                  </div>
                  {item.seen !== 1 &&
                    <div className="btn-seen">
                      <button className="btn p-0" type="button" title="Đánh dấu là đã xem" onClick={() => { markSeen(item.id) }}>
                        <i className="far fa-dot-circle"></i>
                      </button>
                    </div>
                  }
                </div>)
              })
                :
                <p className="p-2">Không có thông báo nào</p>
              }
            </div>
          </div>
          <button type="button" className="navbar-toggler sidebar-toggle-mobile" onClick={() => onToogleMenu(!toogleMenu)}>
            {!toogleMenu ? <i className="fas fa-bars"></i> : <i className="fas fa-times"></i>}
          </button>
        </div>
        <div className={`header-main-menu collapse navbar-collapse pr-0`} id="mobile-navbar">
          {info && (<>
            <ul className="hidden-xs navbar-nav">
              <li className={`navbar-item dropdown header-admin ${show ? "show" : ""}`} >
                <button
                  className="navbar-nav-link dropdown-toggle"
                  href=""
                  type="button"
                  data-toggle="dropdown"
                  aria-expanded="false"
                  onClick={() => setShow(!show)}
                >
                  <div className="admin-title">
                    <h5 className="item-title">
                      {info.fullname} {" "}
                    </h5>
                    <span>{info.chucvu}</span>
                  </div>
                  <div className="admin-img">
                    <img src={info && info.avatar ? info.avatar : Avatar} alt="Admin" />
                  </div>
                </button>
                <div className={`dropdown-menu dropdown-menu-right ${show ? "show" : ""}`} >
                  <div className="item-header">
                    <h6 className="item-title">
                      {info.fullname} {" "}
                    </h6>
                  </div>
                  <div className="item-content">
                    <ul className="settings-list">
                      <li>
                        <Link to="/my-profile">
                          <i className="flaticon-user"></i>Thông tin cá nhân
                        </Link>
                      </li>
                      <li>
                        <a href="#logout" onClick={dologout}>
                          <i className="flaticon-turn-off"></i>Đăng xuất
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>

              <li className={"navbar-item notification-bar dropdown " + (showNoti ? 'show' : '')}>
                <button className="navbar-nav-link dropdown-toggle"
                  type="button"
                  role="button"
                  data-toggle="dropdown"
                  aria-expanded="false"
                  onClick={() => setShowNoti(!showNoti)}
                >
                  <i className="fas fa-bell"></i>
                  {countNoti > 0 && <span className="count-number">{countNoti}</span>}
                </button>
                <div className={`dropdown-menu dropdown-menu-right ${showNoti ? "show" : ""}`} >
                  <div className="w-100 d-flex justify-content-end border-bottom">
                    <button className="btn readall" type="button" onClick={() => markSeenAll()}>Đánh dấu đọc tất cả</button>
                  </div>
                  {listNotification ? listNotification.map((item, i) => {
                    return (<div className={"notification-item p-2 " + (item.seen === 1 ? "seen" : '')} key={i}>
                      {item.avatar ?
                        <img src={item.avatar} alt="" className="avatar" />
                        :
                        ''
                      }
                      <div className="content pl-2" onClick={() => { markSeen(item.id, item.node_url) }}>
                        <div className="w-100">
                          {parse(item.node_type)}
                        </div>
                        <div className="timmer">
                          <small>Lúc {item.time}</small>
                        </div>
                      </div>
                      {item.seen !== 1 &&
                        <div className="btn-seen">
                          <button className="btn p-0" type="button" title="Đánh dấu là đã xem" onClick={() => { markSeen(item.id) }}>
                            <i className="far fa-dot-circle"></i>
                          </button>
                        </div>
                      }
                    </div>)
                  })
                    :
                    <p className="p-2">Không có thông báo nào</p>
                  }
                </div>
              </li>
            </ul>
            <div className="info-user-mobile">
              <div className="w-100 d-flex  u-info">
                <div className="admin-img">
                  <img src={info && info.avatar ? info.avatar : Avatar} alt="Admin" />
                </div>

                <div className="admin-title">
                  <h5 className="item-title">
                    {info.fullname} {" "}
                  </h5>
                  <span>{info.chucvu}</span>
                </div>

              </div>
              <ul className="settings-list">
                <li>
                  <Link to="/my-profile">
                    <i className="flaticon-user"></i>Thông tin cá nhân
                  </Link>
                </li>
                <li>
                  <a href="#logout" onClick={dologout}>
                    <i className="flaticon-turn-off"></i>Đăng xuất
                  </a>
                </li>
              </ul>

            </div>
          </>
          )}
        </div>
      </div>
      <Modal show={showQrCode}
        onHide={() => {
          setShowQrcode(false);
          if (qrScannerRef.current && !isStoppingRef.current) {
            isStoppingRef.current = true;
            qrScannerRef.current.stop()
              .then(() => {
                qrScannerRef.current = null;
                isStoppingRef.current = false;
              })
              .catch((err) => {
                console.warn("Error stop camera:", err);
                isStoppingRef.current = false;
              });
          }
        }}
        animation={true} size="md">
        <Modal.Header closeButton>
          <Modal.Title>Quét mã QR</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div id="reader" style={{ width: "100%" }} />
          {qrResult && (
            <div className="mt-3 text-center text-info">
              <strong>Kết quả:</strong> {qrResult}
            </div>
          )}
        </Modal.Body>
      </Modal>

    </>
  );
}
export default onClickOutside(HeaderBar, {
  handleClickOutside: () => HeaderBar["handleClickOutside_header"],
});
